import TileMedia from "./TileMedia.vue";
import { pluginify } from "./../../util";
export default pluginify(TileMedia);
export { TileMedia };
